import { Directive, ElementRef, Renderer2, Host, HostListener } from '@angular/core';

/**
 * Generated class for the GrdRippleEffectDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[grd-ripple-effect]', // Attribute selector
  host: {
    'tappable': '',
    'role': 'button',
    'style': 'position: relative; overflow: hidden'
  },
})
export class GrdRippleEffectDirective {

  constructor(@Host() public host: ElementRef, public renderer: Renderer2) {
    const div = renderer.createElement('div');
    renderer.addClass(div, 'button-effect');
    renderer.setStyle(div, "display", "block");
    renderer.appendChild(host.nativeElement, div);
    this.host.nativeElement.style.transition = 'background-color .3s ease';
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.setHoverStyle(true);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.setHoverStyle(false);
  }

  setHoverStyle(isHover: boolean) {
    this.host.nativeElement.style.backgroundColor = isHover? '#EFF2F4' : null;
    // this.host.nativeElement.style.borderRadius = '3px';
  }
  // add this on hover
  // background-color: rgba(158, 158, 158, 0.1)
}



// WEBPACK FOOTER //
// ./src/directives/grd-ripple-effect/grd-ripple-effect.ts